// format date and time in format 'YYYY-MM-DD HH:MM'
// en-CA instead of en-US because Canada has better date format
// Go Canada! :)
export const formatDate = (date: string) => {
  return new Date(date).toLocaleString('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};
